import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { HistInfo, RechtsgrundEntryMeta } from '../../../../core/gb-api';
import { Subscription } from 'rxjs';
import { TranslateNamePipe } from '../../../../shared/pipes/simple/translate-name.pipe';
import { FormatConfigService } from '../../../../core/services/format-config.service';
import { ReadMoreComponent } from '../../../../shared/widgets/read-more/read-more.component';
import { ErweiterungConfigResponse, FormatConfigEntry } from '../../../../core/base-api';
import { HistoryDirective } from '../../../../shared/directives/history.directive';
import { KompaktBelegIcpComponent } from '../kompakt-beleg-icp/kompakt-beleg-icp.component';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;
import ElementEnum = FormatConfigEntry.ElementEnum;

@Component({
  selector: 'cap-rechtsgrund-icp',
  imports: [ReadMoreComponent, HistoryDirective, KompaktBelegIcpComponent],
  templateUrl: './rechtsgrund-icp.component.html'
})
export class RechtsgrundIcpComponent implements OnInit, OnDestroy {
  @Input()
  rechtsgrund: RechtsgrundEntryMeta;
  @Input()
  textLimit: number = 40;
  @Input()
  isEigentuemer: boolean = false;
  @Input()
  showBeleg: boolean = true;
  @Input()
  belegTypTemplate: ElementEnum = FormatConfigEntry.ElementEnum.BELEG_TYP03;

  text: string;
  isGeschaeftsmodulCapWebErweiterung: boolean;
  private _histInfo: HistInfo;
  private subscription: Subscription = new Subscription();

  constructor(
    private translateName: TranslateNamePipe,
    private appFormatConfigService: FormatConfigService
  ) {}

  ngOnInit(): void {
    const rechtsgrundCode: string =
      this.rechtsgrund.rechtsgrundCode && this.rechtsgrund.rechtsgrundCode.text
        ? this.translateName.transform(this.rechtsgrund.rechtsgrundCode.text)
        : '';
    this.text = rechtsgrundCode + (this.rechtsgrund.rechtsgrundZusatz ? ' ' + this.rechtsgrund.rechtsgrundZusatz : '');
    this.subscription.add(
      this.appFormatConfigService.erweiterungsConfig$.subscribe((config) => {
        this.isGeschaeftsmodulCapWebErweiterung = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.GESCHAEFTSMODUL_CAP_WEB);
      })
    );
  }

  get histInfo(): HistInfo {
    return this._histInfo ? this._histInfo : this.rechtsgrund.histInfo;
  }

  @Input()
  set histInfo(value: HistInfo) {
    this._histInfo = value;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
